import { create } from 'zustand';

export const useCartStore = create((set) => ({
  cart: [],
  setCart: (data) => set({ cart: data }),
  setQuantity: (rewardId, qty) =>
    set((state) => {
      const quantity = Math.max(qty, 1);
      const index = state.cart.findIndex((i) => i.reward_id === rewardId);

      if (index !== -1) {
        const cart = [...state.cart];
        cart[index] = { ...cart[index], quantity };
        return { cart };
      }

      return {
        cart: [...state.cart, { reward_id: rewardId, quantity }],
      };
    }),

  removeItem: (rewardId) =>
    set((state) => ({
      cart: state.cart.filter((i) => i.reward_id !== rewardId),
    })),
}));
